import { RootState } from '../../store';
import { TopAlertState } from 'reducers/topAlertReducer';

export const getTopAlertState = (state: RootState): TopAlertState =>
  state.topAlertData;
